<template>
    <div class="vm-sponsor-in-out" :class="{ out: type == 'out' }">
        <!-- {{ sponsor }} -->
        <template v-if="type == 'in'">
            <i class="afd afd-chevrons-right fs12"></i>
            <span class="underline black-5 ml8"
                >￥{{ sponsor.current_amount }}{{$t('c.SponsorInOut.text1')}}</span
            >
        </template>
        <template v-else>
            <i class="afd afd-chevrons-left fs12"></i>
            <span class="underline black-5 ml8"
                >￥{{ sponsor.current_amount }}{{$t('c.SponsorInOut.text1')}}</span
            >
        </template>
    </div>
</template>

<script>
export default {
    name: "sponsor-in-out",
    props: {
        type: {
            type: String,
            default() {
                return "in";
            },
        },
        sponsor: {
            type: Object,
            default() {
                return null;
            },
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="stylus" scoped>
.vm-sponsor-in-out{
    display flex
    color $orange
    font-weight normal
    align-items baseline
    font-size fs2rem(12)
    .underline{
        &:after{
            background $orange-5
        }
    }
    &.out{
        color $purple
        .underline{
            &:after{
                background $purple-5
            }
        }
    }
}
</style>
